export const setLocalStorage = (key: string, value: string) => {
  if (window && window.localStorage) {
    return window.localStorage.setItem(key, value);
  }
  return false;
};

export const getLocalStorage = (key: string) => {
  if (window && window.localStorage) {
    return window.localStorage.getItem(key);
  }

  return false;
};

export const removeLocalStorage = (key: string) => {
  if (window && window.localStorage) {
    return window.localStorage.removeItem(key);
  }
};
